import {
  RyeMainContentSidebar,
  RyeSidebarNavItemContent,
  ryeSidebarNavItemClasses,
} from "../rye/RyeMainContentSidebar";
import { buildClasses } from "../utils/buildClasses";
import {
  CASH_FLOW_VIEWS,
  cashFlowViewPath,
  CashFlowView,
} from "./cashFlowViews";
import { Link } from "react-router-dom";

export function CashFlowNav({
  activeView,
}: {
  activeView: CashFlowView;
}): JSX.Element {
  return (
    <RyeMainContentSidebar title="Cash Flow" wide={true}>
      <div className={buildClasses("flex", "flex-col", "gap-1")}>
        {CASH_FLOW_VIEWS.map((entry) => {
          const isSelected = entry.slug === activeView;
          return (
            <Link
              key={entry.slug}
              to={cashFlowViewPath(entry.slug)}
              aria-label={entry.label}
              aria-current={isSelected ? "page" : undefined}
              className={ryeSidebarNavItemClasses(isSelected)}
            >
              <RyeSidebarNavItemContent
                icon={entry.icon}
                label={entry.label}
                isSelected={isSelected}
              />
            </Link>
          );
        })}
      </div>
    </RyeMainContentSidebar>
  );
}
